























































































import { defineComponent, reactive, SetupContext, watch } from '@vue/composition-api';
import { ProductionTimeOption } from '@/models/entities/ProductionTime';

interface State {
  items: ProductionTimeOption[];
  newOption: ProductionTimeOption;
}

interface Props {
  options: ProductionTimeOption[];
  deleteOption: (v: ProductionTimeOption) => {};
  addOption: (v: ProductionTimeOption) => {};
  withLogo: boolean;
}

const Component = defineComponent({
  name: 'ProductionTimeOptionsBlock',

  props: {
    options: [],
    deleteOption: Function,
    addOption: Function,
    withLogo: Boolean,
  },

  setup(props: Props, {}: SetupContext) {
    const productionTimeOptions = props.options;

    const state = reactive({
      items: productionTimeOptions,
      newOption: new ProductionTimeOption({ withLogo: props.withLogo }),
    }) as State;

    watch(
      props,
      (newProps: Props) => Object.assign(productionTimeOptions, newProps.options),
      { immediate: true, deep: true },
    );

    const rules = {
      name: [(v: string) => !!v || 'Name is required'],
      number: [(v: number) => v >= 0 || 'Only positive numbers allowed'],
    };

    function addNewOption() {
      productionTimeOptions.push(state.newOption);
      props.addOption(state.newOption);
      state.newOption = new ProductionTimeOption({ withLogo: props.withLogo });
    }

    function delOption(option: ProductionTimeOption) {
      let index;
      if (option.id !== 0)
        index = productionTimeOptions.findIndex(item => item.id === option.id);
      else
        index = productionTimeOptions.findIndex(
          item =>
            item.name === option.name &&
            item.pricePerPair === item.pricePerPair &&
            item.withLogo === item.withLogo,
        );

      productionTimeOptions.splice(index, 1);
      props.deleteOption(option);
    }

    return {
      state,
      rules,
      addNewOption,
      delOption,
      productionTimeOptions,
    };
  },
});
export default Component;
